import React, { useEffect } from 'react';
import PageHeader from '../innovher/PageHeader';
import { IMG } from '../../lib/images';
import SEO from '../SEO';

export default function PsAcceleratorSeriesPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    const els = document.querySelectorAll('.reveal-up');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-revealed'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  const gallery = [
    IMG.eventPs1,
    IMG.eventPs2,
    IMG.eventPs3,
    IMG.eventPs4,
    IMG.eventPs5,
    IMG.eventPs6,
    IMG.eventPs7,
    IMG.eventPs8
  ];

  return (
    <>
      <SEO 
        title="9 PS Accelerator Series | InnovHer Event"
        description="Highlights from the 9 PS Accelerator Series hosted with InnovHer, bringing founders and ecosystem leaders together."
        keywords="InnovHer accelerator, 9 PS Accelerator Series, startup event Jaipur"
      />
      <PageHeader
        eyebrow="Accelerator Event"
        title={<>9 PS <span className="text-[#ff8ec5]">Accelerator</span> Series</>}
        subtitle="A high-impact acceleration session empowering founders with the insights, networks, and strategies needed to scale."
        image={IMG.eventPs1}
        breadcrumbs={[{ label: 'Events', to: '#' }, { label: '9 PS Accelerator series' }]}
      />

      <section className="relative bg-[#08080a] py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          
          <div className="reveal-up max-w-4xl mx-auto text-center mb-24">
            <h2 className="text-3xl md:text-5xl font-semibold tracking-tight text-white mb-8">Empowering Startups & Driving Innovation</h2>
            <p className="text-lg text-white/60 leading-relaxed text-justify md:text-center">
              The 9 PS Accelerator series brought together visionary founders and industry leaders for a deep-dive into scalable growth strategies. Attendees explored tactical playbooks for product-market fit, capital readiness, and strategic partnerships. The event fostered a dynamic environment for collaborative learning, offering startups a strong foundation and actionable insights to accelerate their journey toward becoming category-defining ventures.
            </p>
          </div>

          <div className="reveal-up">
            <h3 className="text-2xl font-bold text-white mb-8 border-l-4 border-[#ff8ec5] pl-4">Event Gallery</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-4 auto-rows-[250px] md:auto-rows-[300px] gap-4 md:gap-6">
              {gallery.map((src, i) => {
                const getBentoClasses = (index) => {
                  switch(index % 6) {
                    case 0: return "md:col-span-2 md:row-span-2";
                    case 3: return "md:col-span-2 md:row-span-1";
                    default: return "md:col-span-1 md:row-span-1";
                  }
                };
                
                return (
                <div key={i} className={`relative group rounded-3xl overflow-hidden bg-white/5 border border-white/10 ${getBentoClasses(i)}`}>
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors duration-500 z-10 pointer-events-none" />
                  <img 
                    src={src} 
                    alt={`9 PS Accelerator Event Gallery ${i + 1}`} 
                    className="absolute inset-0 w-full h-full object-contain transform group-hover:scale-105 transition-transform duration-700" 
                    loading="lazy"
                  />
                </div>
              )})}
            </div>
          </div>

        </div>
      </section>
    </>
  );
}
